import React, { Fragment } from "react";
import { Link } from "gatsby";
import radiancelogo from "common/assets/image/interior/radiancelogo.svg";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faStar,
  faArrowRight,
} from "@fortawesome/free-solid-svg-icons";
import FooterWrapper from "./footer.style";

const quickLinks = [
  { label: "Home", path: "/" },
  { label: "About Us", path: "/about.php" },
  { label: "Skin Treatments", path: "/skin-treatments.php" },
  { label: "Hair Solutions", path: "/" },
  { label: "Contact Us", path: "/contact.php" },
];

const treatments = [
  { label: "Hair Wig for Men", path: "/wigs-for-men.php" },
  { label: "Hair Patch for Men", path: "/hair-patch-mens.php" },
  { label: "Hair Bonding", path: "/hair-bonding-for-men.php" },
  { label: "Hair Weaving", path: "/hair-weaving-for-mens.php" },
  { label: "Hair Fixing", path: "/hair-fixing.php" },
];

const Footer = ({ hideFloatingActions = false, hideBottomNav = false }) => {
  const handleOpenMore = () => {
    if (typeof document !== "undefined") {
      const toggler = document.querySelector(".navbar-toggler");
      if (toggler) {
        toggler.click();
        window.scrollTo({ top: 0, behavior: "smooth" });
      }
    }
  };

  return (
    <Fragment>
      <FooterWrapper>
        <div className="footer-container">
          <div className="footer-row">
            {/* Column 1: Brand & Trust */}
            <div className="brand-col">
              <Link to="/" className="footer-logo">
                <img
                  src={radiancelogo}
                  alt="Radiance Hair Studio"
                  width="180"
                  height="48"
                />
              </Link>

              <p className="brand-desc">
                Where clinical science meets luxury comfort. Dermatologist-led skin &amp;
                laser treatments in a boutique studio experience.
              </p>

              {/* Desktop-only divider & google badge */}
              <div className="brand-divider desktop-only" />

              <div className="google-badge desktop-only">
                <div className="badge-stars-row">
                  <span className="google-icon">
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" fill="#4285F4" />
                      <path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" fill="#34A853" />
                      <path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.06H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.94l2.85-2.22.81-.63z" fill="#FBBC05" />
                      <path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.06l3.66 2.84c.87-2.6 3.3-4.52 6.16-4.52z" fill="#EA4335" />
                    </svg>
                  </span>
                  <div className="stars">
                    <FontAwesomeIcon icon={faStar} />
                    <FontAwesomeIcon icon={faStar} />
                    <FontAwesomeIcon icon={faStar} />
                    <FontAwesomeIcon icon={faStar} />
                    <FontAwesomeIcon icon={faStar} />
                  </div>
                </div>
                <div className="badge-text">
                  4.9 · 2000+ Google reviews
                </div>
              </div>
            </div>

            {/* Column 2: Quick Links */}
            <div className="links-col">
              <h4 className="footer-col-title">QUICK LINKS</h4>
              <ul className="footer-links-list">
                {quickLinks.map((item) => (
                  <li key={item.label}>
                    <Link to={item.path} className="footer-nav-link">
                      <span>{item.label}</span>
                      <span className="link-arrow">→</span>
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            {/* Column 3: Treatments */}
            <div className="treatments-col">
              <h4 className="footer-col-title">TREATMENTS</h4>
              <ul className="footer-links-list">
                {treatments.map((item) => (
                  <li key={item.label}>
                    <Link to={item.path} className="footer-nav-link">
                      <span>{item.label}</span>
                      <span className="link-arrow">→</span>
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            {/* Column 4: Visit Us */}
            <div className="visit-col">
              <h4 className="footer-col-title">VISIT US</h4>
              <ul className="contact-list">
                <li className="contact-item">
                  <span className="contact-icon-svg">
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#D87B1C" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" />
                      <circle cx="12" cy="10" r="3" />
                    </svg>
                  </span>
                  <div className="contact-text">
                    <a
                      href="https://www.google.com/maps?cid=595399029095088499"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      3rd Floor, A-66, Rajouri Garden, New Delhi, Delhi 110027
                    </a>
                  </div>
                </li>

                <li className="contact-item">
                  <span className="contact-icon-svg">
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#D87B1C" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" />
                    </svg>
                  </span>
                  <div className="contact-text">
                    <a href="tel:+919958585649">+91-99585-85649</a>
                  </div>
                </li>

                <li className="contact-item">
                  <span className="contact-icon-svg">
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#D87B1C" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
                      <polyline points="22,6 12,13 2,6" />
                    </svg>
                  </span>
                  <div className="contact-text">
                    <a href="mailto:contact@radiancehairstudio.com">
                      contact@radiancehairstudio.com
                    </a>
                  </div>
                </li>

                <li className="contact-item">
                  <span className="contact-icon-svg">
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#D87B1C" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <circle cx="12" cy="12" r="10" />
                      <polyline points="12 6 12 12 16 14" />
                    </svg>
                  </span>
                  <div className="contact-text">
                    Mon - Sun: 10:00 AM - 8:00 PM
                  </div>
                </li>
              </ul>
            </div>

            {/* Mobile Google Reviews badge below Quick Links */}
            <div className="mobile-google-badge">
              <div className="badge-stars-row">
                <span className="google-icon">
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" fill="#4285F4" />
                    <path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" fill="#34A853" />
                    <path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.06H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.94l2.85-2.22.81-.63z" fill="#FBBC05" />
                    <path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.06l3.66 2.84c.87-2.6 3.3-4.52 6.16-4.52z" fill="#EA4335" />
                  </svg>
                </span>
                <div className="stars">
                  <FontAwesomeIcon icon={faStar} />
                  <FontAwesomeIcon icon={faStar} />
                  <FontAwesomeIcon icon={faStar} />
                  <FontAwesomeIcon icon={faStar} />
                  <FontAwesomeIcon icon={faStar} />
                </div>
              </div>
              <div className="badge-text">
                4.9 · 300+ Google reviews
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Copyright Bar */}
        <div className="footer-bottom-bar">
          <div className="footer-container">
            <p className="copyright-text">
              © 2025 Radiance Skin &amp; Laser Clinic. All rights reserved.
            </p>
          </div>
        </div>

        {/* Mobile Fixed Bottom Navigation Bar */}
        {!hideBottomNav && (
          <nav className="mobile-bottom-nav" aria-label="Mobile Navigation">
            <Link to="/" className="bottom-nav-item active">
              <span className="bottom-nav-icon">
                <svg width="22" height="22" viewBox="0 0 24 24" fill="#D87B1C" xmlns="http://www.w3.org/2000/svg">
                  <path d="M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z" />
                </svg>
              </span>
              <span className="bottom-nav-label">Home</span>
            </Link>

            <Link to="/services.php" className="bottom-nav-item">
              <span className="bottom-nav-icon">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#D87B1C" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <rect x="3" y="3" width="7" height="7" rx="1.5" />
                  <rect x="14" y="3" width="7" height="7" rx="1.5" />
                  <rect x="14" y="14" width="7" height="7" rx="1.5" />
                  <rect x="3" y="14" width="7" height="7" rx="1.5" />
                </svg>
              </span>
              <span className="bottom-nav-label">Treatments</span>
            </Link>

            <a href="tel:+919958585649" className="bottom-nav-item book-item" aria-label="Book Consultation">
              <div className="floating-book-btn">
                <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#ffffff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
                  <line x1="16" y1="2" x2="16" y2="6" />
                  <line x1="8" y1="2" x2="8" y2="6" />
                  <line x1="3" y1="10" x2="21" y2="10" />
                  <rect x="7" y="13" width="3" height="3" fill="#ffffff" stroke="none" rx="0.5" />
                  <rect x="14" y="13" width="3" height="3" fill="#ffffff" stroke="none" rx="0.5" />
                </svg>
              </div>
              <span className="bottom-nav-label">Book</span>
            </a>

            <Link to="/#featured-in" className="bottom-nav-item">
              <span className="bottom-nav-icon">
                <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#D87B1C" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                  <rect x="3" y="3" width="18" height="18" rx="2" />
                  <circle cx="8.5" cy="8.5" r="1.5" fill="#D87B1C" />
                  <polyline points="21 15 16 10 5 21" />
                </svg>
              </span>
              <span className="bottom-nav-label">Results</span>
            </Link>

            <button type="button" className="bottom-nav-item btn-more" onClick={handleOpenMore}>
              <span className="bottom-nav-icon">
                <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#D87B1C" strokeWidth="2.2" strokeLinecap="round">
                  <line x1="4" y1="6" x2="20" y2="6" />
                  <line x1="4" y1="12" x2="20" y2="12" />
                  <line x1="4" y1="18" x2="20" y2="18" />
                </svg>
              </span>
              <span className="bottom-nav-label">More</span>
            </button>
          </nav>
        )}

        {/* Floating Action Buttons: WhatsApp on top, Call directly below */}
        {!hideFloatingActions && (
          <div className="floating-actions-stack">
            <a
              href="https://api.whatsapp.com/send?phone=+919958585649&text=Hey!%20I'm%20interested%20in%20Radiance%20Hair%20Studio%20services.%20Kindly%20guide%20me%20through%20it"
              target="_blank"
              rel="noopener noreferrer"
              className="floating-action-btn whatsapp-action-btn whatsapp-btn"
              aria-label="WhatsApp"
            >
              <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" fill="currentColor" viewBox="0 0 16 16">
                <path d="M13.601 2.326A7.85 7.85 0 0 0 7.994 0C3.627 0 .068 3.558.064 7.926c0 1.399.366 2.76 1.057 3.965L0 16l4.204-1.102a7.9 7.9 0 0 0 3.79.965h.004c4.368 0 7.926-3.558 7.93-7.93A7.9 7.9 0 0 0 13.6 2.326zM7.994 14.521a6.6 6.6 0 0 1-3.356-.92l-.24-.144-2.494.654.666-2.433-.156-.251a6.56 6.56 0 0 1-1.007-3.505c0-3.626 2.957-6.584 6.591-6.584a6.56 6.56 0 0 1 4.66 1.931 6.56 6.56 0 0 1 1.928 4.66c-.004 3.639-2.961 6.592-6.592 6.592m3.615-4.934c-.197-.099-1.17-.578-1.353-.646-.182-.065-.315-.099-.445.099-.133.197-.513.646-.627.775-.114.133-.232.148-.43.05-.197-.1-.836-.308-1.592-.985-.59-.525-.985-1.175-1.103-1.372-.114-.198-.011-.304.088-.403.087-.088.197-.232.296-.346.1-.114.133-.198.198-.33.065-.134.034-.248-.015-.347-.05-.099-.445-1.076-.612-1.47-.16-.389-.323-.335-.445-.34-.114-.007-.247-.007-.38-.007a.73.73 0 0 0-.529.247c-.182.198-.691.677-.691 1.654s.71 1.916.81 2.049c.098.133 1.394 2.132 3.383 2.992.47.205.84.326 1.129.418.475.152.904.129 1.246.08.38-.058 1.171-.48 1.338-.943.164-.464.164-.86.114-.943-.049-.084-.182-.133-.38-.232" />
              </svg>
            </a>

            <a
              href="tel:+919958585649"
              className="floating-action-btn call-action-btn call-btn"
              aria-label="Call Us"
            >
              <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#FFFFFF" strokeWidth="2.3" strokeLinecap="round" strokeLinejoin="round">
                <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" />
              </svg>
            </a>
          </div>
        )}
      </FooterWrapper>
    </Fragment>
  );
};

export default Footer;
